import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Modal, ModalBody, Button, Label, Col, Row} from 'reactstrap';
import _ from 'lodash';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import {TARGET_TYPE_LABEL_PATH} from "../consentsList/priorConsentsList/PriorConsentsList";
import {AVAILABLE_PRIOR_CONSENT_TYPES} from "../../../constants/constants";
import moment from "moment/moment";

class RemovePriorConsentModal extends Component {
    render() {
        if (_.isNil(this.props.data)) {
            return null;
        }

        return (
            <Modal className="prior-consent-modal" isOpen={this.props.isOpen}
                   toggle={this.handleCancel}>
                <ModalBody>{this.renderModalBody()}</ModalBody>
            </Modal>
        );
    }

    renderModalBody() {
        return (
            <div>
                <Label>
                    {_.get(this.props.translation, 'prior_consents.remove_prior_consent_alert')}
                </Label>
                {this.renderData()}
                <div className="modal-buttons-container">
                    <Button color="secondary"
                            onClick={this.handleCancel}>{_.get(this.props.translation, sharedLabelsPath.cancel_button)}</Button>
                    <Button className="olive-green-btn"
                            onClick={this.handleRemove}>{_.get(this.props.translation, sharedLabelsPath.remove_button)}</Button>
                </div>
            </div>
        );
    }

    renderData = () => {
        let paramsList = [
            {
                key: "target_type",
                title: _.get(this.props.translation, 'prior_consents.target_type_label'),
                value: _.get(this.props.translation, TARGET_TYPE_LABEL_PATH[this.props.data.targetType])
            },
            {
                key: "target_data",
                title: _.get(this.props.translation, 'prior_consents.target_data_label'),
                value: this.getTargetDataValue()
            },
            {
                key: "auto_grant_till",
                title: _.get(this.props.translation, 'prior_consents.auto_grant_till_label'),
                value: moment(this.props.data.enabledTill).format('LL')
            },
            {
                key: "duration",
                title: _.get(this.props.translation, 'prior_consents.duration_label'),
                value: this.getGrantedPeriodDays(this.props.data.grantedPeriodDays)
            }
        ];

        return [..._.map(paramsList, this.getDataRow)]
    };

    getTargetDataValue = () => {
        switch (this.props.data.targetType) {
            case AVAILABLE_PRIOR_CONSENT_TYPES.PERSON:
                return (
                    <span className='target-data'>
                        {!_.isEmpty(this.props.data.metadata.firstName) && !_.isEmpty(this.props.data.metadata.lastName) ?
                            this.props.data.metadata.firstName + ' ' + this.props.data.metadata.lastName + '\n' : ''}
                        <a href={"mailto:" + this.props.data.targetId}>{this.props.data.targetId}</a>
                    </span>
                );
            case AVAILABLE_PRIOR_CONSENT_TYPES.ORGANIZATION:
                return (
                    <span className='target-data'>
                        {this.props.data.targetId}
                    </span>
                );
            default:
                return;
        }

    };

    getGrantedPeriodDays = (periodDays) => {
        let label = periodDays === 1 ? _.get(this.props.translation, 'prior_consents.day_label') : _.get(this.props.translation, 'prior_consents.days_label');

        return periodDays + ' ' + label;
    };

    getDataRow = (params) => {
        if(_.isNil(params.value)) {
            return null;
        }

        return (
            <Row className="modal-form-field-container" key={params.key}>
                <Col sm={4}>
                    {params.title}
                </Col>
                <Col>
                    {params.value}
                </Col>
            </Row>
        );
    };

    handleRemove = (e) => {
        e.preventDefault();

        this.props.onPriorConsentRemove(this.props.data.id);
        this.props.onClose();
    };

    handleCancel = () => {
        this.props.onClose();
        this.props.onCancelRemoving();
    };
}

RemovePriorConsentModal.propTypes = {
    data: PropTypes.object,
    isOpen: PropTypes.bool.isRequired,
    translation: PropTypes.object.isRequired,
    onPriorConsentRemove: PropTypes.func,
    onClose: PropTypes.func,
    onCancelRemoving: PropTypes.func
};

export default RemovePriorConsentModal;



// WEBPACK FOOTER //
// ./src/components/consentManagement/removePriorConsentModal/RemovePriorConsentModal.js